import React, { PropsWithChildren } from 'react';
import { observer } from 'mobx-react';
import HBTooltip, {
    ITooltipProps
} from '@honeybook/hbui/dist/components/HBTooltip/HBTooltip';

interface Props extends Omit<ITooltipProps, 'target'> {
    tooltipText?: ITooltipProps['children'];
}

const TooltipWrapper = ({
    children,
    tooltipText,
    ...props
}: PropsWithChildren<Props>) => {
    if (!tooltipText) {
        return <>{children}</>;
    }

    return (
        <HBTooltip target={children} {...props}>
            {tooltipText}
        </HBTooltip>
    );
};

export default observer(TooltipWrapper);
